/** IDs placed on DOM elements to be skipped to */
export const SKIP_LINK_ID = {
  appMainContent: 'application-main-content',
  appHeaderSearch: 'application-header-search',
  strate: 'strate',
} as const;
